import { MetaDataSet } from '../DataSet/Meta';
import { IDataHandler } from '../IDataHandler';
import { TrackingEventName } from '../TrackingEvent';

export class MetaDataHandler implements IDataHandler<MetaDataSet> {
    public data: MetaDataSet = new MetaDataSet();

    public getEventData(eventName: TrackingEventName): MetaDataSet {
        if (typeof window !== 'undefined') {
            this.data.durationSinceJSEnabled =
                Date.now() - (window as any).JS_INIT_TIME;
        }

        return this.data;
    }
}
